import { Collapse, List } from "@mui/material";
import { Fragment, useEffect, useMemo } from "react";
import useTrees from "../../../../../../Hooks/useTrees";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../../store/slices/UI";
import Divider from "../../../../../UI/GeneralPurpose/Divider";
import MoreLess from "../Botones/MoreLess";
import Category from "./Category";

export const moreTeamsUI = "moreTeams";
export const currentTeamsUI = "currentTeams";
export const shouldExpandTeamsUI = "shouldExpandTeams";

const TeamCategories = () => {
  const { dispatch, UI } = useUIBp();
  const current = UI[currentTeamsUI] ?? [];
  const teamsCount = current.length;
  const expanded = UI[moreTeamsUI];
  const trees = useTrees();

  const teams = useMemo(() => {
    const arr = [];
    for (const key in trees) {
      if (key.match("teams-")) {
        arr.push(trees[key]);
      }
    }
    return arr;
  }, [trees]);

  useEffect(() => {
    if (teamsCount > 6) {
      dispatch(UIactions.setValue({ id: shouldExpandTeamsUI, value: true }));
    } else {
      dispatch(UIactions.setValue({ id: shouldExpandTeamsUI, value: false }));
      dispatch(UIactions.setValue({ id: moreTeamsUI, value: false }));
    }
  }, [dispatch, teamsCount]);

  const teamButtons = teams.map((tree, idx) => <Category key={idx} {...{ tree, idx: 0, level: 0, root: tree[0]?.id }} />);

  return (
    <Fragment>
      <Divider {...{ color: "secondary.light" }} />
      <List
        dense
        sx={{
          width: 250,
          height: "42vh",
          minHeight: 0,
          overflowY: "scroll",
        }}
        disablePadding
      >
        <Collapse in={expanded} collapsedSize="36vh">
          {teamButtons}
        </Collapse>
        <MoreLess {...{ moreUI: moreTeamsUI, shouldExpandUI: shouldExpandTeamsUI }} />
      </List>
    </Fragment>
  );
};

export default TeamCategories;
